export default __webpack_public_path__ + "static/media/img-egt-abp@3x.cd68ad0f.png";